import { GdGoalType } from './graphql-grid';

export interface Goal {
    id: string;
    name: string;
    domain?: string;
}

export interface GoalForStrategy extends Goal {
    type: GdGoalType;
}

export interface GoalForStrategy extends Goal {
    type: GdGoalType;
}

export interface GoalDecl {
    title: string;
    key: string;
    hidden?: boolean;
}

export interface GoalStats {
    conversionRate: number;
    costPerAction: number;
    goalId: string;
    goals: number;
}

export enum AdditionalGoalIds {
    notSet = 'notSet',
    empty = 'empty',
    all = 'all',
    allMeaningfulGoals = 'allMeaningfulGoals'
}
